import loadable from '@loadable/component';

export const SingleVideoPage = loadable(/* #__LOADABLE__ */ () => import('./SingleVideoPage'));
